import React, { useEffect, useRef } from 'react';
import MediaCard from './MediaCard';

function MediaSkeleton() {
  return (
    <div className="mp-media-card mp-media-card--skeleton" aria-hidden="true">
      <div className="mp-media-card__skeleton-thumb" />
      <div className="mp-media-card__skeleton-line" />
      <div className="mp-media-card__skeleton-line mp-media-card__skeleton-line--short" />
    </div>
  );
}

export default function MediaGrid({ items, loading, error, selectedId, onSelect, hasMore, onLoadMore }) {
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (!sentinelRef.current || !hasMore) return undefined;

    const observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        onLoadMore();
      }
    }, {
      root: sentinelRef.current.parentElement,
      rootMargin: '80px',
    });

    observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [hasMore, onLoadMore]);

  if (error) {
    return <p className="mp-media-picker-grid__status">{error}</p>;
  }

  return (
    <div className="mp-media-picker-grid-wrap">
      <div className="mp-media-picker-grid" role="listbox" aria-label="Resultados de mídia">
        {items.map((item) => (
          <MediaCard key={`${item.type}-${item.id}`} item={item} active={selectedId === item.id} onSelect={onSelect} />
        ))}
        {loading && Array.from({ length: 6 }).map((_, index) => <MediaSkeleton key={`media-skeleton-${index}`} />)}
      </div>

      {!loading && !items.length && <p className="mp-media-picker-grid__status">Nenhuma mídia encontrada.</p>}
      <div ref={sentinelRef} className="mp-media-picker-grid__sentinel" />
    </div>
  );
}
